import * as React from 'react';
import ContentLoader from 'react-content-loader';
const Lines = (props) => (React.createElement(ContentLoader, { viewBox: "0 0 200 50", height: 60, width: 200, ...props },
    React.createElement("rect", { x: "0", y: "0", rx: "3", ry: "3", width: "200", height: "10" }),
    React.createElement("rect", { x: "0", y: "20", rx: "3", ry: "3", width: "200", height: "10" }),
    React.createElement("rect", { x: "0", y: "40", rx: "3", ry: "3", width: "200", height: "10" })));
export default Lines;
//# sourceMappingURL=recurring-view-loader.js.map